import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { placeholderSquare } from '../media/images';

const StyledCarPartImage = styled.div`
  background-color: ${p => p.theme.colors.darkBg};
  background-image: url(${p => p.src});
  background-size: cover;
  background-position: 50% 50%;
  height: 0;
  width: 100%;
  padding-bottom: 75%;
`;

export default class CarPartImage extends Component {
  state = {
    loading: true,
    error: false,
    source: placeholderSquare
  };

  static propTypes = {
    src: PropTypes.string.isRequired
  };

  componentDidMount() {
    let image = new Image();
    image.src = this.props.src;

    image.onerror = () =>
      this.setState({
        loading: false,
        error: true,
        source: placeholderSquare
      });

    image.onload = () =>
      this.setState({
        loading: false,
        error: false,
        source: this.props.src
      });
  }

  render() {
    return <StyledCarPartImage src={this.state.source} />;
  }
}
